import { useEffect, useState } from 'react';

const STORAGE_KEY = 'mm_cookie_consent_v1';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

function readConsent(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) return false;
    const parsed = JSON.parse(raw) as { accepted?: boolean; expires?: number };
    if (parsed.accepted !== true) return false;
    if (typeof parsed.expires !== 'number' || Date.now() > parsed.expires) return false;
    return true;
  } catch {
    return false;
  }
}

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!readConsent()) setVisible(true);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accepted: true, expires: Date.now() + TTL_MS }),
      );
    } catch {
      /* private mode / disabled storage — swallow */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-[420px] z-50">
      <div className="bg-l-ink-deep text-l-paper rounded-xl p-5 shadow-[0_16px_40px_rgba(0,0,0,0.25)] flex flex-col gap-3">
        <p className="font-sans text-[14px] leading-[1.6]">
          На сайте используются cookies для аналитики и стабильной работы формы.
          Продолжая пользоваться сайтом, вы соглашаетесь с{' '}
          <a href="/privacy" className="underline underline-offset-2 text-l-paper">
            политикой обработки данных
          </a>.
        </p>
        <div className="flex justify-end">
          <button
            onClick={accept}
            className="h-10 px-5 rounded-[10px] bg-l-terracotta text-white font-sans font-semibold text-[14px] hover:bg-l-marginalia transition-colors"
          >
            Принять
          </button>
        </div>
      </div>
    </div>
  );
}
